import { DEFAULT_BORDER } from 'constants/global';

import CheckCircled from 'assets/icons/check_circled.svg';
import Operation from 'assets/icons/operation.svg';
import Support from 'assets/icons/support.svg';
import Trophy from 'assets/icons/trophy.svg';
import Secuer from 'assets/icons/secuer.svg';
import Finens from 'assets/icons/finens.svg';
import Size from 'assets/icons/size.svg';

const sameStyles = {
  boxSize: 'unset',
  w: { mobile: 'full', xm: '240px', laptop: '356px' },
  minH: { mobile: '220px', tablet: '240px', laptop: '300px' },
  p: { mobile: '0 16px 16px 16px', laptop: '0 32px 32px 32px' },
  borderRadius: { mobile: '20px', laptop: '40px' },
  titleProps: { textStyle: 'h1', fontWeight: '500' },
  iconProps: {
    bgColor: 'unset',
    boxSize: '72px',
    top: { mobile: '0', laptop: '16px' },
    left: { mobile: '0', laptop: '16px' },
  },
};

const grayCard = { bgColor: 'bg.gray', ...sameStyles };
const whiteCard = {
  bgColor: 'bg.white',
  border: DEFAULT_BORDER,
  borderColor: 'line.gray',
  ...sameStyles,
};

export const cloudMigrationSecondExpertiseCardsSliderData = {
  title: 'Результаты миграции в облако',
  titleProps: { maxW: { mobile: '270px', tablet: '360px', laptop: '600px', desktop: 'unset' } },
  cardsData: [
    { src: CheckCircled, title: 'Системы работают без простоев' },
    { src: Finens, title: 'Снижаются расходы' },
    { src: Size, title: 'Быстро увеличиваются мощности под новые проекты и нагрузку' },
    { src: Trophy, title: 'Новые сервисы и обновления запускаются быстрее конкурентов' },
    {
      src: Operation,
      title: 'Устаревшие (legacy) и специфичные приложения работают в облаке без ограничений',
    },
    { src: Secuer, title: 'Данные защищены, соблюдаются требования безопасности и регуляторов' },
    { src: Support, title: 'Команда освобождается от рутинной поддержки ИТ‑инфраструктуры' },
  ],
  cardsStyles: [
    { bgColor: 'bg.neonLight', ...sameStyles },
    whiteCard,
    grayCard,
    { bgColor: 'bg.grayLight', ...sameStyles },
    { bgColor: 'bg.accent', ...sameStyles },
    whiteCard,
    grayCard,
  ],
};
